import { useDispatch } from 'react-redux';
import { addItems } from '../../features/Orders/orderSlice';

const AddToCart = ({ items, styles }) => {
  const dispatch = useDispatch();
  return (
    <div>
      <button
        type="button"
        className={`bg-[#618639] hover:bg-primary-5 md:px-20 px-10  py-4 rounded-[30px] text-[#fff]`}
        onClick={() => dispatch(addItems(items))}
      >
        Add to cart
      </button>
    </div>
  );
};

export default AddToCart;
